import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DisabledControls, ShiftDirection, ShowcaseDetailProduct } from 'src/app/api/models/showcases-dto';
import { TraysService } from 'src/app/api/services/trays.service';
import { LogisticStatus } from 'src/app/enums/logistic-status-enum';
import { ProductStatus } from 'src/app/enums/product-status-enum';
import { TAB } from 'src/app/enums/products.constants';
import { SharedService } from 'src/app/services/shared.service';

@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.scss']
})
export class ProductComponent {

  @Input() selectedProductsInBasket: number = 0;
  @Input() allocationType!: TAB.SHOWCASE | TAB.TRAY | TAB.EXTRA_TRAY | TAB.BASKET;
  @Input() isFreeProduct!: boolean;
  @Input() showControls!: boolean;
  @Input() placeholder!: boolean;
  @Input() isSelected!: boolean;
  @Input() isInBasket!: boolean;
  @Input() isInCaveau!: boolean;
  @Input() readOnly!: boolean;
  @Input() disabled!: DisabledControls;
  @Input() showcase!: string;
  @Input() product!: ShowcaseDetailProduct;

  @Output() handleRemoveProducts: EventEmitter<string[]> = new EventEmitter<string[]>();
  @Output() handleSelectProduct: EventEmitter<ShowcaseDetailProduct> = new EventEmitter<ShowcaseDetailProduct>();
  @Output() handleShowControls: EventEmitter<any> = new EventEmitter<any>();
  @Output() handleShift: EventEmitter<ShiftDirection> = new EventEmitter<ShiftDirection>();

  constructor(
    public sharedService: SharedService,
    public traysService: TraysService,
    public translateService: TranslateService
  ) { }

  getSapcodeClass() {
    if (this.placeholder) {
      return ""
    }
    let { status, logisticStatus } = this.product;
    if (status === 2) {
      return 'appointment-label';
    }
    if (status !== (2 as ProductStatus) && logisticStatus === LogisticStatus.NOT_ARRIVED) {
      return 'alert-label';
    }
    return '';
  }

  getStatus() {
    //Se è isBfsHidden è true allora il nome dello status da visualizzare deve diventare BFS - HIDDEN
    if (this.product.isBfsHidden) {
      return "BFS";
    }
    return this.sharedService.translateStatusText(this.product.status);
    // if (this.traysService.isGenerallyTrayAllocation(this.allocationType)) {
    //   return this.sharedService.translateStatusText(this.product.status);
    // } else {
    //   if (this.product.status === 2) {
    //     return this.translateService.instant('PAGES.PRODUCTS.IN_APPOINTMENT');
    //   }
    //   return this.product.logisticStatus;
    // }
  }

  /**
   * Mostro il pulsante per la rimozione del prodotto solo se:
   * - sono in un tray (non sono in un dettaglio di uno showcase)
   * - non sono un placeholder
   * - non sono un prodotto nel tray FREE PRODUCTS
   */
  canRemoveProduct() {
    if (this.readOnly) {
      return false;
    }
    if (!this.allocationType) {
      return false;
    }
    switch (true) {
      case this.traysService.isShowcaseAllocation(this.allocationType): {
        // if (this.isInCaveau) {
        //   return false;
        // }
        return this.product.status !== 2 && !this.isInCaveau;
      }
      case this.traysService.isGenerallyTrayAllocation(this.allocationType): {
        return !this.placeholder && !this.isFreeProduct;
      }
      //Quando sono in dettaglio non setto l'allocation type (visto che non si sta modificando l'allocazione, ma solo l'ordine)
      default: return false;
    }
  }

  canMoveProduct() {
    if (this.readOnly) {
      return false;
    }
    switch (true) {
      case this.traysService.isShowcaseAllocation(this.allocationType): {
        return !this.isNotAllocable() && this.product.status !== 2;
      }
      case this.traysService.isGenerallyTrayAllocation(this.allocationType): {
        return true
      }
      //Quando sono in dettaglio non setto l'allocation type (visto che non si sta modificando l'allocazione, ma solo l'ordine)
      default: return false;
    }
  }

  selectProduct() {
    if (this.canMoveProduct()) {
      this.handleSelectProduct.emit(this.product);
    }
  }

  allowCopy() {
    return !!this.allocationType;
  }

  copySapCode() {
    navigator.clipboard.writeText(this.product.sapCode);
  }

  isNotAllocable() {
    if (this.product) {
      return !this.product.isAllocable;
    }
    return false;
  }

  handleClick() {
    if (this.readOnly) {
      return;
    }
    if (!!this.allocationType) {
      this.selectProduct();
    } else {
      this.handleShowControls.emit()
    }
  }

  isInExtraTrays() {
    return this.product && Array.isArray(this.product.extraTrays) && this.product.extraTrays.length > 0
  }

  isBackup() {
    return this.product?.isBackup;
  }

  getExtraTrays() {
    if (this.product && Array.isArray(this.product.extraTrays)) {
      // return `Extra trays:\n${this.product.extraTrays.toString().replaceAll(",", "\n")}`
      let extraTrays = this.product.extraTrays.map((et: any) => {
        if (typeof et === 'string') {
          return et;
        } else {
          return et.code;
        }
      })
      return extraTrays.toString().replaceAll(",", "\n");
    }
    return "";
  }
}
